import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  body: {
    maxWidth: theme.design.size.content.full,
    margin: "auto",
    boxSizing: "border-box",
  },

  formControl: {
    minWidth: 60,
    margin: 0,
    backgroundColor: theme.design.color.surface.interactive,
    borderRadius: theme.design.radius.md,
    padding: theme.design.space.sm,

    "& .MuiInputBase-root": {
      height: "24.5px",
      fontSize: "13px",
      color: theme.design.color.text.primary,

      // minWidth: "150px",
      "&.Mui-disabled": {
        "& svg": {
          color: `${theme.design.color.text.muted}!important`,
        },
      },

      "& .MuiSelect-select": {
        textAlign: "center",
        fontFamily: theme.design.typography.fontFamily,

      },

      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },

      "& .MuiSvgIcon-root, & .MuiSelect-icon, & svg": {
        color: theme.design.color.text.primary,
      },
    },

    "& .MuiMenu-paper": {
      padding: "0",
      display: "block",
      minWidth: "auto",
    },

    [theme.breakpoints.down("sm")]: {
      padding: `${theme.design.space.sm}px 0`,
    }
  },

  mdLogoWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: theme.design.space.lg,

    [theme.breakpoints.down("xl")]: {
      width: 200,
    },

    [theme.breakpoints.down("lg")]: {
      display: "none",
    },

    "& img": {
      width: 64,
      height: 64,
      borderRadius: "50%",

      [theme.breakpoints.down("xl")]: {
        width: 48,
        height: 48,
      },
    },

    "&>div": {
      fontSize: 45,
      marginLeft: 16,

      [theme.breakpoints.down("xl")]: {
        fontSize: "32px",
      },
    },
  },
  toolbar: {
    justifyContent: "space-between",
    background: theme.design.gradient.surface.fadeBottom,
    padding: "20px 0 32px",
    zIndex: 101,
    position: "relative",
    height: 64,

    "& *": {
      fontFamily: `${theme.design.typography.fontFamily}!important`,
      fontWeight: 900,
    },
  },
  currency: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    marginRight: "16px",
    gap: "8px",
    color: theme.design.color.text.primary,
    textDecoration: "none",
  },

  userSection: {
    flexGrow: 0,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginRight: "16px",
    gap: 8,

    [theme.breakpoints.down("lg")]: {
      marginRight: "8px",
    },
  },

  headerActionButton: {
    padding: "0",
    minWidth: "32px",
  },

  userProfileBtn: {
    color: theme.design.color.text.primary,
    background: theme.design.color.surface.subtle,
    padding: "8px 24px",
    borderRadius: theme.design.radius.md,
    minWidth: "60px",
    textDecoration: "none",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",

    objectFit: "contain",

    "& span": {
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
    },

    "& img": {
      display: "none",
      marginLeft: 0,
    },

    [theme.breakpoints.down("xl")]: {
      padding: "8px 16px",
    },

    [theme.breakpoints.down("lg")]: {
      "& span": {
        fontSize: 12,
      },
    },

    [theme.breakpoints.down("md")]: {
      "& span": {
        fontSize: "initial",
      },
    },

    [theme.breakpoints.down("sm")]: {
      minWidth: "unset",
      padding: "10px 8px",

      "& span": {
        fontFamily: theme.design.typography.fontFamily,
        fontWeight: 900,
        fontSize: 12,
      },
    },
    position: "relative",
  },

  progress: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    height: 8,
  },

  progressLabel: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: theme.design.color.text.primary,
    fontSize: "10px",
    fontWeight: "bold",
    textShadow: theme.design.brand.header.rankTextShadow,
    userSelect: "none",
  },

  progressBar: {
    height: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: theme.design.brand.header.rankTrack,
    "& .MuiLinearProgress-bar": {
      background: theme.design.brand.header.rankProgress,
    },
  },

  connectWalletBtn: {
    color: theme.design.color.text.primary,

    padding: "8px 16px",
    borderRadius: theme.design.radius.md,
    textTransform: "none",
    minWidth: "48px",
    marginLeft: "8px",

    "& span": {
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
    },

    [theme.breakpoints.down("sm")]: {
      minWidth: "unset",
      padding: "8px",
      "& span": {
        display: "none",
      },
      "& img": {
        marginLeft: 0,
      },
    },
  },
  sidebarNavLink: {
    textDecoration: "none",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    color: theme.design.color.text.secondary,
    display: "flex",
    alignItems: "center",
    gap: "8px",

    "& span": {
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
    },

    "&.active": {
      color: theme.design.color.text.primary,
    },
  },
  sidebarPaper: {
    background: theme.design.color.surface.subtle,
  },
  sidebarHeader: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    height: 64,
    background: theme.design.color.surface.subtle,
    gap: 15,

    "& a": {
      color: theme.design.color.text.primary,
      fontSize: "18px",
      textDecoration: "none",
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
    },
  },
  sidebarLogo: {
    width: 40,
  },
  sideBarConnectWalletBtn: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.design.color.surface.control,
    borderRadius: theme.design.radius.lg,
    color: theme.design.color.text.primary,

    "& span": {
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
    },
  },
  notificationPanel: {
    position: "absolute",
    right: 0,
    top: 0,
    borderRadius: theme.design.radius.xl,
    backgroundColor: theme.design.color.surface.container,
    width: "360px",
    padding: "24px 0 0 0",
    marginTop: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    zIndex: 2,

    fontFamily: theme.design.typography.fontFamily,
  },

  notificationHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 16px 0 32px",

    "& p": {
      margin: "0",
      padding: "0",
      fontSize: "18px",
      fontWeight: "800",
      color: theme.design.color.text.primary,
    },
  },

  notificationList: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "320px",
    overflowY: "scroll",

    "&::-webkit-scrollbar": {
      width: "4px",
    },

    "&::-webkit-scrollbar-track": {
      width: "4px",
      boxShadow: "inset 0 0 5px grey",
      borderRadius: "8px",
      border: `solid 3px ${theme.design.color.overlay.transparent}`,
    },

    "&::-webkit-scrollbar-thumb": {
      width: "4px",
      borderRadius: "8px",
      background: theme.design.color.overlay.transparent,
    },
  },

  notificationEmpty: {
    paddingTop: "16px",
    paddingBottom: "32px",
    display: "flex",
    justifyContent: "center",
    fontSize: "18px",
    color: theme.design.color.overlay.white20,
  },

  notificationListItem: {
    paddingTop: "16px",
    paddingBottom: "16px",
    borderBottom: `1px solid ${theme.design.color.border.default}`,
    display: "flex",
    gap: "8px",
    paddingLeft: "24px",
    "&.read": {
      opacity: "0.5",
    },
  },

  notificationTypeIcon: {
    width: "48px",
    height: "48px",
    backgroundColor: theme.design.color.surface.canvas,
    borderRadius: "50%",
    border: `1px solid ${theme.design.color.border.popover}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  notificationContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    maxWidth: "240px",
    color: theme.design.color.text.primary,

    "& p:first-of-type": {
      fontSize: "14px",
      margin: "0",
    },

    "& p:last-of-type": {
      fontSize: "12px",
      margin: "0",
      color: theme.design.color.text.muted,
    },
  },
  menuListBody: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
  },

  profileLinkContainer: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
    position: "relative",
    boxSizing: "border-box",
    backgroundColor: theme.design.color.surface.subtle,

    "&.noPremium": {
      padding: 3,
      backgroundColor: theme.design.brand.membership.standard,
      borderRadius: theme.design.radius.md,
    },

    "&.plus": {
      padding: 3,
      background: theme.design.brand.membership.plus,
      borderRadius: theme.design.radius.md,
    },

    "&.unlimited": {
      padding: 3,
      background: theme.design.brand.membership.unlimited,
      borderRadius: theme.design.radius.md,
    }
  },

  profilePremiumLabel: {
    fontSize: 12,
    color: theme.design.color.text.secondary,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    position: "absolute",
    top: -20,
    left: "50%",
    transform: "translateX(-50%)",
    width: "100%",
    textAlign: "center",
  },

  profileLinkText: {
    textDecoration: "none",
    color: theme.design.color.text.secondary,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,

    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  balance: {
    display: "flex",
    gap: 8,

    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },

  balanceContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 120,
    gap: 4,

    [theme.breakpoints.down("lg")]: {
      minWidth: 120,
    },

    [theme.breakpoints.down("md")]: {
      minWidth: 100,
    },
  },

  container: {
    display: "flex",
    width: "100%",
    top: 0,
    marginTop: -126,
    overflowY: "hidden",
  },

  contentContainer: {
    flexGrow: 1,
    height: "calc(100vh - 118px)",
    overflow: "auto",
    paddingTop: "128px",

    // Route backgrounds should use the viewport as their sizing/positioning
    // reference instead of stretching with each page's content height.
    "& > *": {
      backgroundAttachment: "fixed",
    },

    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 118px)",
    }
  },

  customTooltip: {
    background: "transparent!important",
    boxShadow: "none!important",
  },

  perksLink: {
    textDecoration: "none",
    color: theme.design.color.text.secondary,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    minWidth: 120,
    marginRight: 8,
    display: "flex",
    flexDirection: "column",
    gap: 4,

    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },

  inboxButton: {
    padding: "0px",
    minWidth: "32px",
    borderRadius: "50%",
  },

  strengthLink: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: theme.design.color.text.primary,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    textDecoration: "none",
    minWidth: 120,
    marginRight: 8,
    gap: 4,

    "& img": {
      width: "12px",
      height: "12px",
    },

    [theme.breakpoints.down("md")]: {
      display: "none"
    },
  },

  killLaunchLink: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    minWidth: 164,
    height: 42,
    padding: "5px 8px",
    marginRight: 8,
    boxSizing: "border-box",
    border: `1px solid ${theme.design.color.action.danger}`,
    borderRadius: theme.design.radius.lg,
    background: `linear-gradient(135deg, color-mix(in srgb, ${theme.design.color.action.danger} 32%, ${theme.design.color.surface.raised}), ${theme.design.color.surface.container})`,
    boxShadow: `0 8px 24px -16px ${theme.design.color.status.danger}`,
    color: theme.design.color.text.primary,
    textDecoration: "none",
    transition: "border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease",
    "&:hover": {
      borderColor: theme.design.color.status.danger,
      boxShadow: `0 8px 28px -10px ${theme.design.color.status.danger}`,
      transform: "translateY(-1px)",
    },
    "&:focus-visible": { outline: `2px solid ${theme.design.color.status.danger}`, outlineOffset: 3 },
    [theme.breakpoints.down("lg")]: { minWidth: 0, marginRight: 4 },
    [theme.breakpoints.down("sm")]: { display: "none" },
  },
  killLaunchIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 26,
    height: 26,
    border: `1px solid ${theme.design.color.action.danger}`,
    borderRadius: theme.design.radius.md,
    backgroundColor: `color-mix(in srgb, ${theme.design.color.action.danger} 32%, ${theme.design.color.surface.container})`,
    color: theme.design.color.status.danger,
  },
  killLaunchCopy: { display: "flex", flexDirection: "column", gap: 1, minWidth: 0 },
  killLaunchLabel: {
    color: theme.design.color.status.danger,
    fontFamily: theme.design.typography.fontFamily,
    fontSize: 9,
    fontWeight: 900,
    letterSpacing: ".06em",
    whiteSpace: "nowrap",
  },
  killLaunchTime: {
    color: theme.design.color.text.primary,
    fontFamily: theme.design.typography.fontFamily,
    fontSize: 13,
    fontWeight: 900,
    fontVariantNumeric: "tabular-nums",
    lineHeight: 1,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("lg")]: { fontSize: 12 },
  },

  deadAccountFullscreen: {
    position: "fixed",
    inset: 0,
    zIndex: 1200,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#0a0a0a",
    overflowY: "auto",
    boxSizing: "border-box",
  },
}));
